import { OauthQuery, SESSION_EXPIRED_PAGE } from "@r-and-a-shared-ui/auth-client";
import { addQueryParam, ensureValidUri, getBaseUrl, getQueryParamByKey, redirectTo } from "@r-and-a-shared-ui/utils";

export const redirectToSessionExpiredPage = () => {
  const returnUri = getBaseUrl(getQueryParamByKey(OauthQuery.REDIRECT_URI));

  const sessionExpiredPage = ensureValidUri(SESSION_EXPIRED_PAGE);
  const sessionExpiredPageWithParams = addQueryParam(sessionExpiredPage, OauthQuery.REDIRECT_URI, returnUri);

  redirectTo(sessionExpiredPageWithParams ? sessionExpiredPageWithParams : sessionExpiredPage);
};